import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import styles from './StepButton.module.scss'

export const StepButton = ({
  ariaLabel,
  className,
  icon,
  onClick,
  isDisabled,
}) => (
  <Button
    className={cx(styles.button, { [className]: Boolean(className) })}
    size="medium"
    variant="text"
    {...{ ariaLabel, icon, onClick, isDisabled }}
  />
)
